<template>
  <div class="idb">
    <header class="idb-head">
      <p class="idb-sub">
        <span class="idb-kind"><font-awesome-icon :icon="kindIcon" />Dashboard</span>
        <span v-if="dashboard && dashboard.created_by">By {{ dashboard.created_by }}</span>
        <span v-if="dashboard && dashboard.updated_at">Updated {{ formatDate(dashboard.updated_at) }}</span>
        <span>Charts read each workflow's latest run</span>
      </p>
      <ExportMenu :exports="exports" size="sm" />
    </header>
    <div ref="page" class="idb-page">
      <AgentPageView :id="dashboardId" :key="dashboardId" />
    </div>
  </div>
</template>

<script>
import { faChartColumn } from '@fortawesome/free-solid-svg-icons';
import AgentPageView from '@/components/Beta/AgentPageView.vue';
import ExportMenu from '@/components/widgetcomponents/library/ExportMenu.vue';
import { exportElementPdf, exportElementPng, fileSlug } from '@/utils/workflowExports';

export default {
  name: 'InsightsDashboard',
  components: { AgentPageView, ExportMenu },
  props: {
    dashboardId: { type: Number, required: true },
    dashboard: { type: Object, default: null },
  },
  data() {
    return { exporting: '', kindIcon: faChartColumn };
  },
  computed: {
    title() {
      return this.dashboard ? this.dashboard.title : 'dashboard';
    },
    exports() {
      return [
        { type: 'pdf', loading: this.exporting === 'pdf', action: () => this.run('pdf') },
        { type: 'chart', menuLabel: 'Image (PNG)', loading: this.exporting === 'png', action: () => this.run('png') },
      ];
    },
  },
  methods: {
    async run(kind) {
      this.exporting = kind;
      try {
        const name = `${fileSlug(this.title)}.${kind}`;
        if (kind === 'pdf') await exportElementPdf(this.$refs.page, name);
        else await exportElementPng(this.$refs.page, name);
      } finally {
        this.exporting = '';
      }
    },
    formatDate(value) {
      return new Date(value).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
    },
  },
};
</script>

<style scoped>
.idb { padding: 24px; display: flex; flex-direction: column; gap: 16px; }
.idb-head { display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.idb-sub { margin: 0; display: flex; flex-wrap: wrap; align-items: center; gap: 16px; font-size: 12px; color: #626264; }
.idb-kind { display: inline-flex; align-items: center; gap: 4px; font-weight: 600; color: #353537; }
.idb-page { background: #FFFFFF; border: 1px solid #E8E9E9; border-radius: 8px; padding: 16px; }
</style>
